import { DETERMINAR_PAGINA_ATUAL_USUARIO } from '../types'

export default function determinarPaginaAtualCidade (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_USUARIO,
    payload: paginaAtual
  }
}
